import {Controller} from "stimulus"

/**
 * Simple controller for toggling visibility of a content element.
 * Toggles the "hidden" class on the content target.
 *
 * Usage:
 *   <div data-controller="visibility-toggle">
 *     <button data-action="click->visibility-toggle#toggle">Toggle</button>
 *     <div data-target="visibility-toggle.content" class="hidden">
 *       Content to show/hide
 *     </div>
 *   </div>
 */
export default class extends Controller {
  static targets = ["content"]

  toggle() {
    this.contentTarget.classList.toggle("hidden")
  }

  show() {
    this.contentTarget.classList.remove("hidden")
  }

  hide() {
    this.contentTarget.classList.add("hidden")
  }
}
